import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FundDDQRun } from '@core/models/fund-ddq-run.model';
import { PaginationParams } from '@core/api/api-entity.service';
import { FundDDQRunState, FundDDQRunStore } from './fund-ddq-run.store';

@Injectable({ providedIn: 'root' })
export class FundDDQRunQuery extends Query<FundDDQRunState> {
  constructor(protected store: FundDDQRunStore) {
    super(store);
  }

  selectFundDDQRuns(): Observable<FundDDQRun[]> {
    return this.select((state) => state.fundDDQRuns);
  }

  selectLoading(): Observable<boolean> {
    return this.select((state) => state.loading);
  }

  selectError(): Observable<string | null> {
    return this.select((state) => state.error);
  }

  /**
   * Select a Fund DDQ Run by product UID
   * @param productUid The product UID to search for
   * @returns Observable of the found FundDDQRun or undefined
   */
  selectFundDDQRunByProductUid(productUid: string): Observable<FundDDQRun | undefined> {
    return this.selectFundDDQRuns().pipe(
      map((runs) => runs.find((run) => run.productUid === productUid)),
    );
  }

  /**
   * @deprecated Use selectFundDDQRunByProductUid instead
   * Select a Fund DDQ Run by product UID (legacy method name)
   */
  selectFundDDQRunByUid(productUid: string): Observable<FundDDQRun | undefined> {
    return this.selectFundDDQRunByProductUid(productUid);
  }

  getFundDDQRuns(): FundDDQRun[] {
    return this.getValue().fundDDQRuns;
  }

  getLoading(): boolean {
    return this.getValue().loading;
  }

  getError(): string | null {
    return this.getValue().error;
  }

  selectPagination(): Observable<PaginationParams | null> {
    return this.select((state) => state.pagination);
  }

  getPagination(): PaginationParams | null {
    return this.getValue().pagination;
  }
}
